import autocompleteClasses from "@mui/material/Autocomplete/autocompleteClasses";
export const MuiAutocompleteTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`.${autocompleteClasses.endAdornment}`]: {
                    button: {
                        borderRadius: dt.borderRadius.pill,
                    },
                },
            },
        },
    };
};
